import { BackLink } from '@/components/back-link';
import { ImportForm } from './import-form';
import { GenerateForm } from './generate-form';
import { NewTemplateTabs } from './tabs';

export function NewTemplatePage() {
  return (
    <div className="space-y-5">
      <BackLink to="/templates">Templates</BackLink>
      <div>
        <h1 className="text-2xl">New template</h1>
        <p className="text-sm text-muted-foreground">Generate one from a brief and your images, or import existing HTML / a zip.</p>
      </div>
      <NewTemplateTabs generate={<GenerateForm />} import={<ImportForm />} />
    </div>
  );
}
